module.exports = __webpack_public_path__ + "static/media/ballLoad.566053d9.gif";